module.exports = __webpack_public_path__ + "static/media/promo-otdyh-dlya-krymchan.72064067.jpg";